import styled from "styled-components";


export const Layout = styled.div`
  color: #a90000;
  padding: 40px 40px;
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 24px;
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 24px;
  white-space: pre-line;
  margin-top: 15px;
`;